<template>
  <div
    id="step_options_view"
    class="flex flex-col gap-6 overflow-y-scroll custom_scrollbar"
    style="height: 70vh"
  >
    <div
      v-for="(section, key) in activeStepOptions"
      :key="key"
      class="flex flex-col gap-2"
    >
      <span class="text-[11px] font-semibold secondary_color">{{
        section.title
      }}</span>

      <div class="flex flex-col gap-2">
        <div
          v-for="option in section.options"
          :key="option.id"
          class="flex flex-row justify-between p-3 border rounded-lg cursor-pointer type_option"
          :class="{
            disabled: stepStatus[option.id]?.disabled,
            inactive: !stepStatus[option.id]?.active,
            hidden: !stepStatus[option.id]?.active,
          }"
          @click="!stepStatus[option.id]?.disabled && option.action()"
        >
          <div class="flex flex-row items-center gap-3">
            <ThemeImage
              :icon="option.icon"
              :alt="option.id + '_icon'"
              class="size-6"
            />
            <div class="flex flex-col gap-1">
              <span class="text_color text-sm font-semibold">{{
                option.title
              }}</span>
              <span class="secondary_color text-xs font-normal">{{
                option.description
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { getStepOptionsActiveState } from "@/src/helpers/stepOptionsHelper";

const props = defineProps({
  stepOptions: {
    type: Object,
    required: true,
  },
  stepStatus: {
    type: Object,
    required: true,
  },
});

const activeStepOptions = computed(() => {
  const activeStates = getStepOptionsActiveState();
  const filteredOptions = {};

  Object.entries(props.stepOptions).forEach(([key, section]) => {
    if (activeStates[key]) {
      filteredOptions[key] = section;
    }
  });

  return filteredOptions;
});
</script>

<style scoped>
.type_option {
  background-color: var(--white-opacity-2);
  border: 1px solid var(--white-opacity-8);
  transition: all 0.3s ease;
}

.type_option:not(.disabled):hover {
  border: 1px solid var(--white-opacity-60);
}

.type_option.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--white-opacity-2);
}

.type_option.inactive {
  opacity: 0.7;
}

.hidden {
  display: none;
}
</style>
